import { AssetPreviewVideoController } from './asset-preview-video.controller'

function assetPreviewVideo () {
  return {
    restrict: 'E',
    scope: {
      template: '=',
      setTemplate: '=',
      location: '<',
      previewFlags: '='
    },
    templateUrl: '/core/directives/asset-preview-video/asset-preview-video.html?$$REVISION$$',
    controller: AssetPreviewVideoController
  }
}
export { assetPreviewVideo }
